import { render } from "./learningCertificate.vue?vue&type=template&id=8a43a3fc&scoped=true"
import script from "./learningCertificate.vue?vue&type=script&lang=js"
export * from "./learningCertificate.vue?vue&type=script&lang=js"

import "./learningCertificate.vue?vue&type=style&index=0&id=8a43a3fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a43a3fc"]])

export default __exports__